define('OutSystems/ReactWidgets/Input',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataConversion", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ReactView/Widget", "react", "./Throttling"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, Widget_1, React, Throttling_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Input = void 0;
    var Input = (function (_super) {
        tslib_1.__extends(Input, _super);
        function Input(props, context) {
            var _this = _super.call(this, props, context) || this;
            if (_this.props.extendedProperties) {
                var customThrottlingValue = _this.props.extendedProperties[Throttling_1.Throttling.CustomThrottlingProperty];
                if (typeof customThrottlingValue !== "undefined") {
                    _this.throttleValue = parseInt(customThrottlingValue, 10);
                }
            }
            _this.ShowDefaultValue = Input_1.getShowDefaultValue(props);
            _this.state = { value: _this.convertFromModel(props.variable.value) };
            _this.throttling = new Throttling_1.Throttling();
            return _this;
        }
        Input_1 = Input;
        Input.getShowDefaultValue = function (props) {
            if (props.extendedProperties) {
                var customShowDefaultValue = props.extendedProperties[Input_1.ShowDefaultValueProperty];
                if (typeof customShowDefaultValue !== "undefined") {
                    return customShowDefaultValue.toLowerCase() === "true";
                }
            }
            return false;
        };
        Input.prototype.getCorrectDatePartForType = function (value, inputType) {
            switch (this.props.inputType) {
                case 5:
                    return value.toString("yyyy-MM-ddTHH:mm");
                case 4:
                    return value.toString("yyyy-MM-dd");
                case 3:
                    return value.toString("HH:mm");
                default:
                    break;
            }
            throw new Error("A correct datetime type is required");
        };
        Input.prototype.convertFromModel = function (value) {
            switch (this.props.inputType) {
                case 5:
                case 4:
                case 3:
                    if (Input_1.isNullDate(value) && !this.ShowDefaultValue) {
                        return "";
                    }
                    return this.getCorrectDatePartForType(value, this.props.inputType);
                case 2:
                    if (parseFloat(value) === 0.0 && !this.ShowDefaultValue) {
                        return "";
                    }
                    return value;
                default:
                    return value;
            }
        };
        Input.isNullDate = function (value) {
            return value.equals(DataTypes_1.DateTime.defaultValue);
        };
        Object.defineProperty(Input.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "htmlElement", {
            get: function () {
                return this.getHTMLNode();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "inputedValue", {
            get: function () {
                return this.htmlElement.value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "inputedValueValidity", {
            get: function () {
                return this.htmlElement.validity;
            },
            enumerable: false,
            configurable: true
        });
        Input.prototype.onChange = function (e) {
            var _this = this;
            var _a;
            var elem = e.target;
            if (this.props.inputType === 5 && ((_a = this.inputedValueValidity) === null || _a === void 0 ? void 0 : _a.stepMismatch)) {
                elem.value = elem.value.substr(0, 16);
            }
            this.variable.value = elem.value;
            this.setState({ value: elem.value });
            if (this.props.onChange) {
                this.throttling.throttle(function () { return _this.props.onChange(); }, this.throttleValue);
            }
        };
        Input.prototype.preparePromptForBrowsersThatDontSupportHTML5 = function (inputType) {
            var inputElem = this.htmlElement;
            switch (inputType) {
                case 4:
                    inputElem.placeholder = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.dateFormat;
                    break;
                case 3:
                    inputElem.placeholder = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.timeFormat;
                    break;
                case 5:
                    inputElem.placeholder = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.dateTimeFormat;
                    break;
                default:
                    break;
            }
        };
        Input.prototype.componentDidMount = function () {
            var inputType = this.props.inputType;
            if (Input_1.supportsHTML5Inputs === undefined) {
                var inputElem = this.htmlElement;
                if (inputElem.type !== Input_1.toInputHtmlType(inputType)) {
                    Input_1.supportsHTML5Inputs = false;
                }
                else {
                    Input_1.supportsHTML5Inputs = true;
                }
            }
            if (this.props.prompt === undefined &&
                (inputType === 4 || inputType === 5 || inputType === 3)) {
                if (!Input_1.supportsHTML5Inputs) {
                    this.preparePromptForBrowsersThatDontSupportHTML5(inputType);
                }
            }
        };
        Input.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            var elem = this.getHTMLNode();
            var nextValue = nextProps.variable.value.valueOf().toString();
            var canonicalValueInInput = DataConversion_1.JSConversions.convertTo(elem.value, this.variable.type).valueOf().toString();
            var valueAndModelAreEquivalent = canonicalValueInInput === nextValue;
            var showDefaultValue = Input_1.getShowDefaultValue(nextProps);
            if ((this.shouldUpdateValue(nextProps.variable) && !valueAndModelAreEquivalent) ||
                showDefaultValue !== this.ShowDefaultValue) {
                this.ShowDefaultValue = showDefaultValue;
                this.updateValue(nextProps.variable.value);
            }
        };
        Input.prototype.componentWillUnmount = function () {
            this.throttling.dispose();
        };
        Input.prototype.updateValue = function (value) {
            this.setState({ value: this.convertFromModel(value) });
        };
        Input.toInputHtmlType = function (type) {
            switch (type) {
                case 0:
                    return "text";
                case 1:
                    return "password";
                case 2:
                    return "number";
                case 3:
                    return "time";
                case 4:
                    return "date";
                case 5:
                    return "datetime-local";
                case 6:
                    return "tel";
                case 7:
                    return "email";
                case 8:
                    return "search";
                default:
                    return "";
            }
        };
        Input.prototype.shouldUseDefaultProperty = function (propertyName) {
            return !this.props.extendedProperties || !this.props.extendedProperties.hasOwnProperty(propertyName);
        };
        Input.prototype.render = function () {
            var _this = this;
            var inputAttributes = {
                "data-input": "",
                className: this.props.style,
                disabled: !this.props.enabled,
                required: this.props.mandatory,
                type: Input_1.toInputHtmlType(this.props.inputType),
                placeholder: this.props.prompt,
                onChange: function (event) { return _this.onChange(event); },
                value: this.state.value.toString(),
                "aria-required": this.props.mandatory,
                "aria-describedby": this.getId() + Input_1.DescribedBySuffix,
            };
            if (this.throttleValue !== Throttling_1.Throttling.DefaultThrottlingInterval) {
                inputAttributes[Throttling_1.Throttling.CustomThrottlingRuntimeAttribute] = this.throttleValue;
            }
            if (this.ShowDefaultValue !== Input_1.ShowDefaultValueDefault) {
                inputAttributes[Input_1.ShowDefaultValueRuntimeAttribute] = this.ShowDefaultValue;
            }
            switch (this.props.inputType) {
                case 2:
                    var type = this.props.variable.type;
                    switch (type) {
                        case DataTypes_1.DataTypes.Integer:
                            if (this.shouldUseDefaultProperty("pattern")) {
                                inputAttributes.pattern = "[0-9]*";
                            }
                            inputAttributes.max = DataTypes_1.Constants.MAX_INTEGER_VALUE;
                            break;
                        case DataTypes_1.DataTypes.LongInteger:
                            if (this.shouldUseDefaultProperty("pattern")) {
                                inputAttributes.pattern = "[0-9]*";
                            }
                            inputAttributes.max = DataTypes_1.Constants.MAX_LONGINTEGER_VALUE.toString();
                            break;
                        case DataTypes_1.DataTypes.Currency:
                        case DataTypes_1.DataTypes.Decimal:
                            if (this.shouldUseDefaultProperty("pattern")) {
                                inputAttributes.pattern = "[0-9]+.[0-9]*";
                            }
                            if (this.shouldUseDefaultProperty("step")) {
                                inputAttributes.step = "any";
                            }
                            break;
                        default:
                            break;
                    }
                    break;
                case 3:
                case 5:
                case 4:
                    break;
                default:
                    if (this.props.maxLength > 0) {
                        inputAttributes.maxLength = this.props.maxLength;
                    }
                    break;
            }
            this.fillWithBuiltinProperties(inputAttributes);
            delete inputAttributes[Throttling_1.Throttling.CustomThrottlingProperty];
            var outerSpanAttributes = {
                className: "input-" + inputAttributes.type,
            };
            return (React.createElement("span", tslib_1.__assign({}, outerSpanAttributes),
                React.createElement("input", tslib_1.__assign({}, inputAttributes)),
                this.createValidationElement()));
        };
        var Input_1;
        Input.ShowDefaultValueDefault = false;
        Input.ShowDefaultValueRuntimeAttribute = "data-show-default-value";
        Input.ShowDefaultValueProperty = "show-default-value";
        Input.supportsHTML5Inputs = undefined;
        Input = Input_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Input);
        return Input;
    }(Widget_1.InputWithVariableWidget));
    exports.Input = Input;
});
//# sourceMappingURL=Input.js.map;
